import React, { useEffect, useState } from "react";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { ImageFilters } from "../../Utils/Enums";
import Image from "../../Components/Reusable/Image";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import RoutesPath from "../../Utils/RoutesPath";
import { Link, useNavigate, useParams } from "react-router-dom";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors } from "../../Utils/Utils";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { CirclesWithBar } from "react-loader-spinner";


const ShowResult = () => {
    const { mockTest_id, order_id } = useParams()
    const [resultData, setResultData] = useState([]);
    const [loading, setLoading] = useState(true); // Add loading state
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(7);

    const getShowResults = async () => {
        setLoading(true); // Set loading true before API call
        try {
            const response = await StudentDashboardServices.getShowResults(
                mockTest_id,
                order_id,
                offset,
                limit,
            );
            setResultData(response.data);
            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        } finally {
            setLoading(false); // Set loading false after API call
        }
    };

    useEffect(() => {
        getShowResults();
    }, [offset]);
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">Show Results</h1>
                        <Link to={RoutesPath.mymocktest}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link>
                    </div>
                    <div className="table_container" style={{ display: "block" }}>
                        {loading ? (
                            <div className="text-center d-flex justify-content-center">
                                <CirclesWithBar
                                    height="80"
                                    width="80"
                                    color="#F6821F"
                                    ariaLabel="bars-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>
                        ) : (
                            <>
                                {resultData.length === 0 ? (
                                    <div className="no-records-container text-center" >
                                        <div className="no-record-image " >
                                            <Image src={PngImages.no_record} className="img-fluid" />
                                        </div>
                                        <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>                                       

                                    </div>
                                ) : (
                                    <div className="Tableorderhistory" style={{ overflowX: "auto" }}>
                                        <table
                                            className="table mb-0 mt-3"
                                            id="dtHorizontalExample"
                                            cellSpacing="0"
                                            width="100%"
                                        >
                                            <thead>
                                                <tr >
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Sr No.
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Date & Time
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "30%" }}>
                                                        Mock Test Name
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                                        Marks
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                                        Result
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg_light">
                                                {resultData.map((item, index) => (
                                                    <tr key={index} className="table_heading">
                                                        <td className="small-medium-text fw-600 " style={{ paddingLeft: '40px' }}>{limit * offset + (index + 1)}</td>
                                                        <td className="small-medium-text  fw-600">{item.submitted_date}</td>
                                                        <td className="small-medium-text  fw-600">{item.mockTestName}</td>
                                                        <td className="small-medium-text  fw-600">{Math.max(item.score, 0)}/{item.totalNumberOfMarks}</td>
                                                        <Link to={`${RoutesPath.viewresult}/${item.mockTest_id}/${item.mockTestSubmissions_id}`}>
                                                            <td className="small-medium-text fw-600 orangeAccentColor " style={{ padding: '22px 0px' }}>View Result

                                                            </td></Link>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    </div>

                                )}
                            </>
                        )}

                    </div>
                    <div className="row mt-3 align-items-center parentcustomnavbtn">
                        <div className="col-md-6 col-sm-6 col-auto"><p className=" small-text fw-500 mb-0" style={{ opacity: '0.5', fontStyle: "italic" }}>
                            {availableDataCount > 0
                                ? `Showing ${Math.min(offset * limit + 1, availableDataCount)} to ${Math.min((offset + 1) * limit, availableDataCount)} of ${availableDataCount} entries`
                                : "Showing No Entries"}</p>
                        </div>
                        <div className="col-md-6 col-sm-6 col-auto">  {generatePaginationFooter(
                            availableDataCount,
                            limit,
                            offset,
                            setOffset
                        )}</div>

                    </div>
                </div>
            </div>
        </div>

    );
};

export default ShowResult;
